"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _omit = _interopRequireDefault(require("lodash/fp/omit"));

var _queryBuilder2 = _interopRequireDefault(require("@sprinx/query-builder"));

var _useProductFilterBuilderServiceCall = _interopRequireDefault(require("./useProductFilterBuilderServiceCall"));

/* eslint-disable no-console */
// import inToQuery from '@sprinx/query-builder/mergePartWithQuery';
//
// const buildFilter = (parentFilter, filter) => filter s in to query
// const mergeFilter = (parentQuery, filter) => [...(filter || []), { field: '__parent', toQuery: () => parentQuery }];
function useFilterFieldOptions(_ref) {
  var buildFilter = _ref.buildFilter,
      field = _ref.field,
      filter = _ref.filter,
      parentFilter = _ref.parentFilter,
      strategy = _ref.strategy;

  // console.log('filter', filter);
  // console.log('strategy', strategy);
  var _React$useState = _react.default.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      filterOptions = _React$useState2[0],
      setFilterOptions = _React$useState2[1]; // console.log('filterOptions', filterOptions);


  var apiCall = (0, _useProductFilterBuilderServiceCall.default)();

  _react.default.useEffect(function () {
    var partialFilter = (0, _omit.default)([field], filter); // console.log('partialFilter', partialFilter);
    // const finalFilter = mergeFilter(parentFilter, partialFilter);

    var finalFilter = buildFilter(parentFilter, partialFilter); // console.log('finalFilter', finalFilter);
    // console.log('qqqq');

    var _queryBuilder = (0, _queryBuilder2.default)(null, finalFilter, {}, null),
        query = _queryBuilder.query; // console.log('query', query);


    apiCall({
      query: query,
      strategy: strategy
    }).then(function (r) {
      // console.log('rrr', r);
      setFilterOptions(r);
    }).catch(function (e) {
      console.log(e); // setFilterOptions({});
    });
  }, [apiCall, buildFilter, field, filter, parentFilter, strategy]);

  return filterOptions; // return {
  //   options: [
  //     {
  //       label: 'zelena', // nebo multikulti
  //       value: 'green',
  //       count: 3,
  //     },
  //     {
  //       label: 'cerv', // nebo multikulti
  //       value: 'red',
  //       count: 3,
  //     },
  //   ],
  // };
}

var _default = useFilterFieldOptions;
exports.default = _default;